import { ComponentManager, DetailViewContext, UIListener, } from 'radpresentation.htmlclient.defaultviewextensions';
import UIListenerUtility from '@/Utils/UIListenerUtility';

class NachrichtUIListener extends UIListener
{

    public onAssociationUpdated(context: DetailViewContext, relation: string)
    {
        if (relation === 'Vorlage')
        {
            context.refreshContextFromServer();
        }
        super.onAssociationUpdated(context, relation);
    }

    public override onDetailViewReady(context: DetailViewContext)
    {
        this.makeReadonly(context);
    }

    public override onAfterCallOperation(context: DetailViewContext, operation: string, args: any)
    {
        this.makeReadonly(context);
    }

    private makeReadonly(context) {
        const versendet = context.genericObject.getValue('SendetAt') as string;
        if (versendet && versendet !== '')
        {
            UIListenerUtility.makeEverythingReadonly(context);
            context.toolBar.getElementByMethodName('Send').isEnabled(false);
        }
    }
}

ComponentManager.setUIListener('NachrichtUIListener', NachrichtUIListener, 'ONVHTMLViewExtension');